import { Storage } from 'services';
import { allFlags } from './flags';

function getDefaultValue(key: any) {
  return allFlags
    .map((section: any) => section.flags.filter((flag: any) => flag.key === key))
    .filter((flags: any) => flags.length)[0][0].defaultValue;
}

export function getFlag(key: string) {
  const flag = Storage.get('devFlag: ' + key);
  if (flag) {
    return JSON.parse(flag);
  } else {
    return getDefaultValue(key);
  }
}

export function setFlag(key: string, value: boolean) {
  if (value !== getDefaultValue(key)) {
    return Storage.set('devFlag: ' + key, value.toString());
  } else {
    return Storage.remove('devFlag: ' + key);
  }
}
